<template>
  <v-snackbar
    :color="color"
    v-model="errorLogin"
    :timeout="timeout"
    :top="y === top"
    :right="x === right"
  >
    {{ text }}

    <v-btn color="white" text icon @click="errorLogin = false">
      <v-icon>mdi-close-circle</v-icon>
    </v-btn>
  </v-snackbar>
</template>

<script>
import eventBus from "../../main";
export default {
  name: "Alert",
  data: () => ({
    color: "",
    text: "",
    right: "right",
    top: "top",
    errorLogin: false,
    timeout: 6000,
    y: "top",
    x: "right"
  }),
  created() {
    const self = this;
    eventBus.$on("openInfo", function(payload) {
      self.errorLogin = payload.errorLogin;
      self.color = payload.color;
      self.text = payload.text;
      self.right = payload.right;
      if (payload.top) self.top = payload.top;
    });
  }
};
</script>

<style scoped></style>
